import React, { useEffect, useRef } from "react";
import { connect } from "react-redux";

import useMap from "@app/component/map/FeaturedMap/utils/useMap";
import BaseLayerData from "@app/scene/map/store/layers/BaseLayerData";
import { getTrafficLayerData } from "@app/scene/map/store/selectors";
import { RootState } from "@app/store/rootReducer";

interface Props {
  data: BaseLayerData;
}

const TrafficLayer: React.FC<Props> = ({ data }) => {
  const { map } = useMap();
  const trafficLayer = useRef(new google.maps.TrafficLayer());

  useEffect(() => {
    trafficLayer.current.setMap(data.visible ? map : null);
    return () => {
      // we need this destructor when switching to other modes to remove
      // traffic from the map
      // eslint-disable-next-line react-hooks/exhaustive-deps
      trafficLayer.current.setMap(null);
    };
  }, [data.visible, map]);

  return null;
};

const mapStateToProps = (state: RootState) => ({
  data: getTrafficLayerData(state),
});

export default connect(mapStateToProps)(TrafficLayer);
